import React from "react";

function ReviewCard({ title, children }) {
  return (
    <div
      style={{
        border: "1px solid #e5e7eb",
        borderRadius: 12,
        background: "#f9fafb",
        marginBottom: 18,
        padding: 20,
      }}
    >
      <div
        style={{
          color: "#2563eb",
          fontWeight: 600,
          fontSize: 14,
          marginBottom: 10,
          letterSpacing: 1,
          textTransform: "uppercase",
        }}
      >
        {title}
      </div>
      {children}
    </div>
  );
}

function InnerCard({ children }) {
  return (
    <div
      style={{
        background: "#fff",
        borderRadius: 8,
        padding: 16,
        fontWeight: 500,
        fontSize: 16,
        border: "1px solid #e5e7eb",
        marginBottom: 12,
      }}
    >
      {children}
    </div>
  );
}

const TEST_TYPE_LABELS = {
  yellow: "Yellow Test Tube",
  purple: "Purple Test Tube",
  both: "Both Test Tubes",
};

function groupByCategory(biomarkers) {
  const grouped = {};
  biomarkers.forEach((b) => {
    const cat = b.category;
    if (!grouped[cat]) grouped[cat] = [];
    grouped[cat].push(b);
  });
  return grouped;
}

export default function StepReview({ selectedType, selectedBiomarkers }) {
  const grouped = groupByCategory(selectedBiomarkers || []);

  return (
    <div>
      <ReviewCard title="Selected Test Tube">
        <InnerCard>{TEST_TYPE_LABELS[selectedType] || selectedType}</InnerCard>
      </ReviewCard>

      <ReviewCard title="Selected Biomarkers">
        {Object.entries(grouped).map(([cat, items]) => (
          <InnerCard key={cat}>
            <div style={{ fontWeight: 600, marginBottom: 8 }}>{cat}</div>
            <ul className="ps-3 mb-0">
              {items.map((b) => (
                <li key={b.id}>{b.name}</li>
              ))}
            </ul>
          </InnerCard>
        ))}
      </ReviewCard>
    </div>
  );
}
